import { takeLatest, put, all, call } from 'redux-saga/effects';
import { goBack } from 'connected-react-router';
import { rolesAPI } from 'resources/api';
import Types from './types';
import { processError } from 'state/utils';

function* fetchStartAsync({payload}) {
  try {
    const res = yield rolesAPI.getAll(payload);
    yield put({ type: Types.FETCH_SUCCESS, payload: res });
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.FETCH_ERROR, payload: message });
  }
}

function* fetchStart() {
  yield takeLatest(Types.FETCH_START, fetchStartAsync);
}

function* fetchOneStartAsync({ payload }) {
  try {
    const res = yield rolesAPI.getOne(payload);
    yield put({ type: Types.FETCH_ONE_SUCCESS, payload: res });
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.FETCH_ERROR, payload: message });
  }
}

function* fetchOneStart() {
  yield takeLatest(Types.FETCH_ONE_START, fetchOneStartAsync);
}

function* updateStartAsync({ payload }) {
  try {
    const { item, goBack: shouldGoBack } = payload;
    yield rolesAPI.update(item);
    yield put({ type: Types.UPDATE_SUCCESS, payload });
    yield put({ type: Types.FETCH_START, payload: {} });
    if (shouldGoBack) yield put(goBack());
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.UPDATE_ERROR, payload: message });
  }
}

function* updateStart() {
  yield takeLatest(Types.UPDATE_START, updateStartAsync);
}

function* createStartAsync({ payload }) {
  try {
    yield rolesAPI.create(payload);
    yield put({ type: Types.CREATE_SUCCESS, payload });
    yield put({ type: Types.FETCH_START });
    yield put(goBack());
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.CREATE_ERROR, payload: message });
  }
}

function* createStart() {
  yield takeLatest(Types.CREATE_START, createStartAsync);
}

function* deleteStartAsync({ payload }) {
  try {
    yield rolesAPI.delete(payload);
    yield put({ type: Types.DELETE_SUCCESS, payload });
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.DELETE_ERROR, payload: message });
  }
}

function* deleteStart() {
  yield takeLatest(Types.DELETE_START, deleteStartAsync);
}

export default function* sagas() {
  yield all([call(fetchStart), call(fetchOneStart), call(updateStart), call(createStart), call(deleteStart)]);
}
